<template>
    <b-container class="event-carousel" v-if="showingEvent">
        <b-row>
            <b-col>
                <b-carousel :interval="0"
                            :controls="JSON.parse(showingEvent.images).length > 1">
                    <b-carousel-slide v-for="image in JSON.parse(showingEvent.images)">
                        <template slot="img">
                            <b-container class="event-carousel-image-wrapper">
                                <div class="event-carousel-image-slide" :style="getEventImageStyle(image)"></div>

                                <!--<b-img class="event-carousel-image" :src="getURL(image)"></b-img>-->
                            </b-container>
                        </template>
                    </b-carousel-slide>
                </b-carousel>
            </b-col>
        </b-row>
        <b-row class="font-size-50">
            <b-col>
                <EventDetail :event="showingEvent"
                             :can-enroll="isEventAcceptingEnrollment"
                             :enrolled="false"
                             no-border
                             @enroll="enrollEvent(showingEvent)"></EventDetail>
            </b-col>
        </b-row>
        <b-row class="event-carousel-switch-event-btns mt-3 mb-3">
            <b-col v-if="prevEvent" class="text-left" sm="12" md="6">
                <b-row @click="showingEventIndex -= 1" class="event-carousel-switch-event-btn">
                    <b-col cols="2">
                        <font-awesome-icon icon="arrow-left"></font-awesome-icon>
                    </b-col>
                    <b-col cols="10">
                        <b-row class="event-carousel-switch-event-title font-size-40">
                            <b-col>{{$t('event.prev_event')}}</b-col>
                        </b-row>
                        <b-row class="event-carousel-switch-event-name font-size-60">
                            <b-col v-html="prevEvent.name"></b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-col>
            <b-col v-else></b-col>
            <b-col v-if="nextEvent" class="text-right" sm="12" md="6">
                <b-row @click="showingEventIndex += 1" class="event-carousel-switch-event-btn">
                    <b-col class="text-right" cols="10">
                        <b-row class="event-carousel-switch-event-title font-size-40">
                            <b-col>{{$t('event.next_event')}}</b-col>
                        </b-row>
                        <b-row class="event-carousel-switch-event-name font-size-60">
                            <b-col v-html="nextEvent.name"></b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="2">
                        <font-awesome-icon icon="arrow-right"></font-awesome-icon>
                    </b-col>
                </b-row>
            </b-col>
            <b-col v-else></b-col>
        </b-row>

        <b-modal id="enrollmentSuccessModal"
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <b-container class="enrollment-success-container">
                <b-row>
                    <b-col class="enrollment-success-icon">
                        <font-awesome-icon :icon="['far', 'envelope']"></font-awesome-icon>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="enrollment-success-title">
                        {{$t('enrollment_success.title')}}
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        {{$t('enrollment_success.description')}}
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-button class="enrollment-success-close-btn"
                                  @click="$bvModal.hide('enrollmentSuccessModal')">{{$t('close')}}
                        </b-button>
                    </b-col>
                </b-row>
            </b-container>
        </b-modal>
    </b-container>
</template>

<script>
    import {HOST} from '../main';
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faDownload, faArrowLeft, faArrowRight} from '@fortawesome/free-solid-svg-icons'
    import {faEnvelope} from '@fortawesome/free-regular-svg-icons'
    import EventDetail from "./EventDetail"
    import {DateTime} from 'luxon'
    import $ from 'jquery'

    library.add(faDownload, faEnvelope, faArrowLeft, faArrowRight);

    export default {
        name: 'PreviewEventCarousel',
        components: {EventDetail},
        props: {
            categoryId: String,
        },
        data() {
            return {
                events: [],
                enrollments: {},

                showingEventIndex: 0,
                jumpToEventId: this.$route.query.e,
            };
        },
        mounted() {
            this.getEvents();
        },
        watch: {
            categoryId(newVal) {
                this.events = [];
                this.getEvents();
            },
            showingEventIndex(newVal) {
                window.scrollTo(0, 0);
            },
        },
        computed: {
            showingEvent() {
                if (this.showingEventIndex < this.events.length) {
                    return this.events[this.showingEventIndex];
                } else {
                    return null;
                }
            },
            prevEvent() {
                if (0 < this.showingEventIndex) {
                    return this.events[this.showingEventIndex - 1];
                } else {
                    return null;
                }
            },
            nextEvent() {
                if (this.showingEventIndex < this.events.length - 1) {
                    return this.events[this.showingEventIndex + 1];
                } else {
                    return null;
                }
            },
            enrollmentIds() {
                let enrollmentMap = {};

                this.enrollments.forEach(function (enrollment) {
                    enrollmentMap[enrollment.event.id] = {
                        "-1": enrollment.event.id,
                        "1": enrollment.event.id,
                        "2": enrollment.session ? enrollment.session.id : null,
                        "3": enrollment.series ? enrollment.series.id : null,
                    }[enrollment.event.signup_mode];
                });

                return enrollmentMap
            },
            isEventAcceptingEnrollment() {
                return DateTime.fromISO(this.showingEvent.signup_from) < new Date() && new Date() < DateTime.fromISO(this.showingEvent.signup_until);
            },
        },
        methods: {
            getEvents() {
                let v = this;
                this.$callAPI('hkiarace/event/preview/', {category_id: this.categoryId}, function (response) {
                    this.events = response.body.events;

                    let enrollmentMap = {};

                    response.body.enrollments.forEach(function (enrollment) {
                        if (!(enrollment.event.id in enrollmentMap)) {
                            enrollmentMap[enrollment.event.id] = enrollment;
                        } else if (enrollmentMap[enrollment.event.id].create_at < enrollment.create_at) {
                            // Only keep latest enrollment
                            enrollmentMap[enrollment.event.id] = enrollment;
                        }
                    });

                    this.enrollments = response.body.enrollments;

                    if (this.jumpToEventId) {
                        let index = 0;
                        this.events.forEach(function (e, i) {
                            if (e.id === v.jumpToEventId) {
                                index = i;
                            }
                        });

                        this.showingEventIndex = index;
                    }
                });
            },
            getEventImageStyle(image) {
                return {
                    'background-image': `url("${HOST}static/` + image + '")',
                    'background-size': 'contain',
                    'background-position': 'center',
                    'background-repeat': 'no-repeat'
                }
            },
            getURL(f) {
                if (f instanceof File) {
                    return URL.createObjectURL(f);
                } else {
                    return 'api/static/' + f;
                }
            },
            //Event Detail
            enrollEvent() {

            },
        },
    }
</script>

<style lang="less">
    .event-carousel {
        .carousel {
            .carousel-indicators li {
                border: 1px solid black;

                &.active {
                    background-color: black;
                }
            }
        }

        .event-carousel-image-slide {
            /*position: relative;*/
            width: 100%;
            padding-top: 33.19274568%;
        }

        .event-detail-wrapper {
            // font-size: 1.2rem;

            .row {
                margin-bottom: 15px;
            }

            .event-list-cell-title {
                font-size: 1.75rem;
                font-weight: bold;
                border-bottom: 2px solid;
                text-align: left;
            }

            .event-list-cell-field-header {
                font-weight: bold;
                text-align: left;
            }

            .event-list-cell-field-content {
                text-align: left;
            }
            .event-list-cell-description {
                text-align: initial !important;
                margin-bottom: 72px;
            }

            .event-detail-btns {
                bottom: 15px;
                right: 15px;

                button {
                    // width: 75%;
                }

                .event-list-cell-download-poster-btn {
                    background-color: #f99918;
                    color: white;
                    border: solid 3px #f99918;

                    &:hover {
                        background-color: transparent;
                        color: #f99918;
                    }
                }

                .event-list-cell-detail-btn {
                    background-color: black;
                    color: white;
                    font-weight: bold;
                    border: solid 3px black;

                    &:hover {
                        background-color: transparent;
                        color: black;
                    }
                }
            }
        }

        .event-carousel-switch-event-btns {

            .event-carousel-switch-event-btn {
                align-items: center;
                cursor: pointer;
            }

            .event-carousel-switch-event-title {
                // font-size: 1.2rem;
            }

            .event-carousel-switch-event-name {
                // font-size: 1.5rem;
            }

            .fa-arrow-left, .fa-arrow-right {
                font-size: 2rem;
            }
        }
    }

    #enrollmentSuccessModal {
        text-align: center;

        .enrollment-success-container {
            padding-top: 48px;
            font-size: 1.5rem;

            .row {
                margin-bottom: 2rem;
            }

            .enrollment-success-icon {
                font-size: 5rem;
            }

            .enrollment-success-title {
                font-weight: bold;
                font-size: 2.5rem;
            }

            .enrollment-success-close-btn {
                background-color: black;
                border-radius: 0;
                width: 100%;
                font-size: 1.5rem;
            }
        }
    }
</style>